<template>
<div>

    <p>Specify which companies will use this plan and the plan/account number with the provider.</p>

    <table class="table pt-4">
        <thead>
            <tr>
                <th>Company</th>
                <th>Enabled</th>
                <th>Plan number</th>
            </tr>
        </thead>

        <tbody>
            <tr v-for="company in client.companies">
                <td>
                    {{ company.name }}
                    <div v-if="conflictFor(company.id)"><small class="text-danger">{{ conflictFor(company.id) }}</small></div>
                </td>
                <td><form-input label="" v-model="formData.companies_enabled[company.id]" type="checkbox" :form-check-inline="true" @update:modelValue="toggleCompany(company.id)" /></td>
                <td><form-input label="" v-model="formData['plan_number_' + company.id]" :errors="errors['plan_number_' + company.id]" type="text" maxlength="64" :disabled="!formData.companies_enabled[company.id]" /></td>
            </tr>
        </tbody>
    </table>
</div>
</template>

<script>
import moment from 'moment'
import FormMixin from '@/mixins/Form'

export default {
    props: ['initialValue', 'client', 'plans', 'planType', 'startsOn'],
    mixins: [FormMixin],
    data() {
        return {
            formData: this.makeFormData(),
            errors: {},
        }
    },
    methods: {
        // The plan a company already runs of the type being created, if it would still
        // be running when this one starts. A company runs one plan per type at a time.
        blockingPlan(companyId) {
            if (!this.planType || !this.startsOn) {
                return null
            }

            return (this.plans || []).find(p => (
                p.company_id == companyId
                && p.plan_type == this.planType
                && p.is_active
                && (!p.ends_on || p.ends_on >= this.startsOn)
            )) || null
        },
        conflictFor(companyId) {
            const plan = this.blockingPlan(companyId)
            if (!plan) {
                return ''
            }

            if (!plan.ends_on) {
                return `Already runs a ${plan.plan_type_pretty} plan with no end date. Stop that plan first.`
            }

            const earliest = moment(plan.ends_on).add(1, 'days').format('MM/DD/YYYY')
            return `Already runs a ${plan.plan_type_pretty} plan through ${moment(plan.ends_on).format('MM/DD/YYYY')}. The replacement can start no earlier than ${earliest}.`
        },
        validate() {
            this.errors = {}
            this.formErrors = []
            const originalValidate = FormMixin.methods.validate.bind(this)
            let isValid = originalValidate()

            const enabled = this.client.companies.filter(c => this.formData.companies_enabled[c.id])
            if (enabled.length < 1) {
                this.formErrors.push('Enable this plan for at least one company.')
                isValid = false
            }

            enabled.forEach(c => {
                const conflict = this.conflictFor(c.id)
                if (conflict) {
                    this.formErrors.push(`${c.name}: ${conflict}`)
                    isValid = false
                }
            })

            return isValid
        },
        getFormLabels() {
            const result = {}

            this.client.companies.forEach(c => {
                result['plan_number_' + c.id] = 'Plan number'
            })

            return result
        },
        getFormRules() {
            const result = {}

            this.client.companies.forEach(c => {
                if (this.formData.companies_enabled[c.id]) {
                    result['plan_number_' + c.id] = {presence: {allowEmpty: false}}
                }
            })

            return result
        },
        makeFormData() {
            const result = {
                companies_enabled: {},
            }

            this.client.companies.forEach(c => {
                result.companies_enabled[c.id] = this.initialValue[c.id] ? true : false
                result['plan_number_' + c.id] = this.initialValue[c.id] ? this.initialValue[c.id] : ''
            })

            return result
        },
        getPlanNumbers() {
            const result = {}

            this.client.companies.forEach(c => {
                if (this.formData.companies_enabled[c.id]) {
                    result[c.id] = this.formData['plan_number_' + c.id]
                }
            })

            return result
        },
        toggleCompany(companyId) {
            if (this.formData.companies_enabled[companyId]) {
                // pass
            }
            else {
                this.formData['plan_number_' + companyId] = ''
            }

        },
    },
}
</script>
